import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { environment } from '../../../../environments';
import {
  OrganizationManagementService
} from '../../zentility/_shared/_zen-legacy-common/zen-common-services/_services/organization-management.service';
import { BillMergeRequest, BillMergeResponse } from './api-models';

/**
 * Service for merging dual utility + supplier bills into a single bill.
 *
 * Calls POST /v4/ai/bill-merge which applies field-by-field merge rules:
 * - Dates, usage, distribution → from utility bill
 * - Supply charges, supplier info → from supplier bill
 * - Taxes → combined when both present
 * - Total → recalculated from merged components
 */
@Injectable({
  providedIn: 'root'
})
export class BillMergeService {
  private baseUrl = environment.apiBaseUrl;

  constructor(
    private http: HttpClient,
    private orgMgtSvc: OrganizationManagementService
  ) {}

  /**
   * Merge two bill extractions (utility + supplier) into a single bill.
   *
   * @param request Contains either raw extraction data or existing bill IDs
   * @returns Merged extraction with per-field decisions and warnings
   */
  merge(request: BillMergeRequest): Observable<BillMergeResponse> {
    const url = `${this.baseUrl}/v4/organizations/${this.orgMgtSvc.getOrganizationId()}/ai/bill-merge`;
    return this.http.post<BillMergeResponse>(url, request).pipe(take(1));
  }
}
